// TODO switch to a DS colors (impacts to PSF?)
export const GREEN = '#3eca8a';
export const GRAY = '#adadac';
